module.exports = __webpack_public_path__ + "images/category_lp/electric_tool/store_images/4_12c604f8443ec437c5bf2e6418bb20f9.png";